import {ADD_SERVICER,LOAD_SERVICERS,UPDATE_SERVICER,LOAD_FORMS,ADD_FORM,UPDATE_FORM} from './types';

export function addServicer(servicer)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:ADD_SERVICER,
                payload:servicer
            })
    }
}
export function addForm(form)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:ADD_FORM,
                payload:form
            })
    }
}
export function updateForm(form)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:UPDATE_FORM,
                payload:form
            })
    }
}
export function updateServicer(servicer)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:UPDATE_SERVICER,
                payload:servicer
            })
    }
}
export function loadServicers(servicers)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:LOAD_SERVICERS,
                payload:servicers
            })
    }
}
export function loadForms(forms)
{
    return function(dispatch)
    {
        dispatch(
            {
                type:LOAD_FORMS,
                payload:forms
            })
    }
}
